import * as types from './types'
// import globals from '@/plugins/globals.js'
// import store from '@/store'
import storage from '@/plugins/storage'

export default {

  [types.SET_OPENING_HOURS](state, openingHours) {
    let _openingHours = []

    // Ensure openingHours is an array, not a string
    if (typeof openingHours === 'string') {
      try {
        openingHours = JSON.parse(openingHours) // Convert JSON string to array
      } catch (error) {
        console.error('Failed to parse openingHours JSON:', error)
        return
      }
    }

    if (Array.isArray(openingHours)) {
      for (let type of openingHours) {
        if (type.ScheduledDate && type.Notes && type.Notes !== '') {
          _openingHours.push({
            notes: type.Notes,
            scheduledDate: type.ScheduledDate,
            startTime: type.startTime,
            endTime: type.endTime
          })
        } else {
          _openingHours.push({
            dayOfWeek: type.dayOfWeek,
            startTime: type.startTime,
            endTime: type.endTime || null // Ensure endTime exists, default to null
          })
        }
      }
    }

    // Save to state
    state.openingHours = _openingHours

    // Persist in local storage
    storage.local.setItem(types.SESSION_OPENINGHOURS, JSON.stringify(state.openingHours))
  },
  [types.SET_ISSHOPOPEN](state, isOpen) {
    state.isOpen = isOpen
    storage.local.setItem(types.SESSION_ISSHOPOPEN, isOpen)
  },
  [types.SET_TENANT_DETAILS](state, value) {
    if (value !== undefined && value !== null) {
      state.tenantDetails = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/mutations.js